import React from 'react';
import _ from 'underscore';
import PropTypes from 'prop-types';
import { withStateStore } from '@bingads-webui/with-state-store';
import { Listener } from './listener';
import { UnifiedNotificationQueueShared } from './unified-notification-queue-shared';
import { contextPropTypes } from './constants';
import { getContext, isContextChanged, generateViewAllLinkInOldUI } from './utils';

export class UnifiedNotificationQueueContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      context: getContext({ parameters: props.context, uid: props.uid }),
    };

    this.Listener = new Listener();
    this.Listener.onNavigate(this.navigationHandler);
  }

  componentWillUnmount() {
    this.Listener.unbind();
  }

  get contextLogContent() {
    const {
      context: {
        cid, aid, uid, campaignId,
      },
    } = this.state;

    return `cid=${cid}, aid=${aid}, uid=${uid}, cmpid=${campaignId}`;
  }

  logContent = (content = '') => `Context: ${this.contextLogContent}; Content: ${_.isString(content) ? content : JSON.stringify(content)};`;

  navigationHandler = () => {
    const newContext = getContext({ uid: this.props.uid });
    if (isContextChanged(newContext, this.state.context)) {
      this.setState({
        context: newContext,
      });
    }
  };

  render() {
    return (
      <UnifiedNotificationQueueShared
        context={this.state.context}
        i18n={this.props.i18n}
        permissions={this.props.permissions}
        ccBaseUrl={this.props.ccBaseUrl}
        logger={this.props.logger}
        notificationStore={this.props.notificationStore}
        isUINext={this.props.isUINext}
        generateViewAllLink={generateViewAllLinkInOldUI(this.props.campaignDomain)}
        baseHelpUrl={this.props.baseHelpUrl}
      />
    );
  }
}

UnifiedNotificationQueueContainer.propTypes = {
  context: PropTypes.shape({
    cid: contextPropTypes,
    aid: contextPropTypes,
    campaignId: contextPropTypes,
  }),
  permissions: PropTypes.shape({}),
  uid: contextPropTypes.isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  campaignDomain: PropTypes.string.isRequired,
  ccBaseUrl: PropTypes.string.isRequired,
  logger: PropTypes.shape({
    mark: PropTypes.func,
    startProcess: PropTypes.func,
    endProcess: PropTypes.func,
    trace: PropTypes.func,
    error: PropTypes.func,
  }),
  notificationStore: PropTypes.shape({
    dismissNQAll: PropTypes.func,
    state: PropTypes.shape({
      nQNotificationList: PropTypes.arrayOf(PropTypes.shape({})),
      nQShouldShowPreviewBar: PropTypes.bool,
    }),
  }),
  isUINext: PropTypes.bool,
  baseHelpUrl: PropTypes.string,
};

UnifiedNotificationQueueContainer.defaultProps = {
  logger: {
    mark: _.noop,
    startProcess: _.noop,
    endProcess: _.noop,
    trace: _.noop,
    error: _.noop,
  },
  permissions: {},
  context: {},
  notificationStore: {
    dismissNQAll: _.noop,
    state: {
      nQNotificationList: [],
      nQShouldShowPreviewBar: null,
    },
  },
  isUINext: false,
  baseHelpUrl: '',
};

export function createUnifiedNotificationQueueContainerWithStateStore(stateStore) {
  return withStateStore(UnifiedNotificationQueueContainer, stateStore, 'notificationStore');
}
